<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      Connect.S Logs
    </portal>
    <tabable-card cols="12">
      <tabable-card-content title="Update Log" @show="refreshUpdateLog">
        <hm-card-inner>
          <hm-input-date ref="updateLogDate"
                         v-model="updateLogDate"
                         :max-date="today"
                         label="Date"
                         cols="12 2@hd 2@desktop 6@tablet"
                         name="updateLogDate"
                         @input="refreshUpdateLog"
          />
        </hm-card-inner>
        <hm-card-inner v-if="!isEmpty(updateLog)" :full-size="true" >
          <hm-table :hover="true" columns="2">
            <template slot="table-head">
              <div class="hm-table__th">Date</div>
              <div class="hm-table__th">URL</div>
            </template>
            <template v-for="entry in updateLog">
              <div class="hm-table__td" @click="openUrl(entry.log)">{{ entry.date }}</div>
              <div class="hm-table__td" @click="openUrl(entry.log)">{{ entry.log }}</div>
            </template>
          </hm-table>
        </hm-card-inner>
      </tabable-card-content>
      <tabable-card-content title="Failed Channel Log" @show="refreshFailedLog">
        <hm-card-inner>
          <hm-button class="btn--orange"
                     icon-left="refresh"
                     cols="12 6@tablet 2@desktop"
                     @click="retryFailed">Retry Failed</hm-button>
        </hm-card-inner>
        <hm-card-inner v-if="!isEmpty(failedLog)" :full-size="true">
          <hm-table :hover="true" columns="6">
            <template slot="table-head">
              <div class="hm-table__th">OTA</div>
              <div class="hm-table__th">Room Type</div>
              <div class="hm-table__th">Rate Plan</div>
              <div class="hm-table__th">Date/Time</div>
              <div class="hm-table__th">PMS-Ticket-ID</div>
              <div class="hm-table__th">CM-Ticket-ID</div>
            </template>
            <template v-for="entry in failedLog">
              <template v-for="update in entry.updates">
                <div class="hm-table__td" @click="openUrl(update.URL)">{{ entry.OTA }}</div>
                <div class="hm-table__td" @click="openUrl(update.URL)">{{ entry.roomtypeid }}</div>
                <div class="hm-table__td" @click="openUrl(update.URL)">{{ entry.rateplanid }}</div>
                <div class="hm-table__td" @click="openUrl(update.URL)">{{ update.update_time }}</div>
                <div class="hm-table__td" @click="openUrl(update.URL)">{{ update.pmsticketid }}</div>
                <div class="hm-table__td" @click="openUrl(update.URL)">{{ update.channelticketid }}</div>
              </template>
            </template>
          </hm-table>
        </hm-card-inner>
      </tabable-card-content>
      <tabable-card-content title="Rates & Inventory Log" @show="refreshRateInventoryLog">
        <hm-card-inner>
          <hm-input-select v-model="raRoomType" label="Room Type" cols="12 2@hd 2@desktop 6@tablet" @input="refreshRateInventoryLog">
            <option v-for="it in hotelSettings.roomTypes.filter(it => !isEmpty(it.additionalFields.CM_SU_ID))" :value="it.id">{{ it.name[hotelSettings.details.primaryLanguage] }} ({{ it.additionalFields.CM_SU_ID }})</option>
          </hm-input-select>
          <hm-input-select v-model="raRatePlan" label="RatePlan" cols="12 2@hd 2@desktop 6@tablet" @input="refreshRateInventoryLog">
            <option v-for="it in hotelSettings.ratePlans.filter(it => !isEmpty(it.additionalFields.CM_SU_ID))" :value="it.id">{{ it.name[hotelSettings.details.primaryLanguage] }} ({{ it.additionalFields.CM_SU_ID }})</option>
          </hm-input-select>
          <hm-input-date ref="startDate"
                         v-model="raStartDate"
                         label="From"
                         cols="12 2@hd 2@desktop 6@tablet"
                         name="startDate"
                         @input="refreshRateInventoryLog" />
          <hm-input-date ref="endDate"
                         v-model="raEndDate"
                         :min-date="raStartDate"
                         :min-date-inclusive="true"
                         :max-days="730"
                         :max-date="maxDate"
                         label="Until"
                         cols="12 2@hd 2@desktop 6@tablet"
                         name="endDate"
                         @input="refreshRateInventoryLog" />
        </hm-card-inner>
        <template v-if="!isEmpty(rateInventoryLog)">
          <hm-card-inner>
            <hm-button class="btn--orange"
                       icon-left="link"
                       cols="12 6@tablet 2@desktop"
                       @click="openRAW(rateInventoryLog)">Open RAW</hm-button>
          </hm-card-inner>
          <hm-card-inner v-for="entry in rateInventoryLog" :title="`${entry.date}`" :key="entry.date">
            <!--            <hm-input :value="entry.inventory"-->
            <!--                      :disabled="true"-->
            <!--                      label="Inventory"-->
            <!--                      cols="12 6@tablet 3@dekstop 2@hd start-1"/>-->
            <hm-col :grid="true" cols="12 6@desktop 4@hd start-1">
              <label-value-dotted :value="entry.inventory" label="Inventory" />
              <label-value-dotted v-for="rate in entry.rate" :value="`${ $options.filters.toCurrency(parseFloat(rate.rate)) }&nbsp;${ hotelSettings.details.currency }`" :label="`${ rate.NumberOfGuests } Person(s)`" :key="rate.NumberOfGuests" />
            </hm-col>
          </hm-card-inner>
        </template>
      </tabable-card-content>
      <tabable-card-content title="Currently Mapped OTA Channels" @show="refreshChannelLog">
        <template v-if="!isEmpty(channelLog)">
          <template v-for="(value, key) in channelLog">
            <hm-card-inner v-for="(mapping, idx) in value" :title="`${enums.ADDITIONAL_DATA.ChannelManagerSuChannel.byCode[key] || 'Unknown'} (${key})`" :key="`${key}-${idx}`">
              <hm-input :value="mapping.Status"
                        :disabled="true"
                        :key="`status-${idx}`"
                        label="Status"
                        cols="12 6@tablet 3@dekstop 2@hd start-1"/>
              <hm-input :value="mapping.ChannelHotelID"
                        :disabled="true"
                        :key="`channelHotelId-${idx}`"
                        label="ChannelHotelID"
                        cols="12 6@tablet 3@dekstop 2@hd"/>
              <hm-col :key="`roomIDs-${idx}`" cols="12 start-1">
                <u>Room Types</u><br/>
                <ul>
                  <template v-if="!isEmpty(mapping.RoomIDs)">
                    <template v-for="roomType in hotelSettings.roomTypes.filter(it => mapping.RoomIDs.includes(it.additionalFields.CM_SU_ID))">
                      <li>{{ roomType.name[hotelSettings.details.primaryLanguage] }} ({{ roomType.additionalFields.CM_SU_ID }})</li>
                    </template>
                  </template>
                </ul>
              </hm-col>
              <hm-col :key="`rateplans-${idx}`" cols="12 start-1">
                <u>Rate Plans</u>
                <template v-if="!isEmpty(mapping.Rateplans)">
                  <template v-for="ratePlan in mapping.Rateplans">
                    <div style="border: 1px solid black;font-family: monospace;line-height: 2;user-select: text;padding: 1rem;margin-top: 1rem;margin-bottom: 1rem;">
                      <i>{{ ratePlan.ChannelMappingName }}</i><br/>
                      <b>Pricing Model: </b> {{ ratePlan.PricingModel }}<br/>
                      <b>Mapping Status: </b> {{ ratePlan.MappingStatus }}<br/>
                      <template v-if="ratePlan.DisableRates"><b>Disabled Rates: </b> {{ ratePlan.DisableRates }}<br/></template>
                      <template v-if="ratePlan.DisableAvailablity"><b>Disabled Availability: </b> {{ ratePlan.DisableAvailablity }}<br/></template>
                      <b>Room Type:</b> {{ ratePlan.ChannelRoomID }} ({{ ratePlan.PMSRoomID }} - {{ hotelSettings.roomTypes.find(it => it.additionalFields.CM_SU_ID === ratePlan.PMSRoomID).name[hotelSettings.details.primaryLanguage] }})<br/>
                      <b>Rate Plan:</b> {{ ratePlan.ChannelRateID }} ({{ ratePlan.PMSRateID }} - {{ hotelSettings.ratePlans.find(it => it.additionalFields.CM_SU_ID === ratePlan.PMSRateID).name[hotelSettings.details.primaryLanguage] }})<br/>
                      <template v-if="isArray(ratePlan.Pricing)">
                        <template v-for="pricing in ratePlan.Pricing">
                          <b>{{ pricing.ApplicableNoOfGuest }} Pax:</b> Price x {{ pricing.Multiplier }} + {{ pricing.Surcharge }}<br/>
                        </template>
                      </template>
                      <template v-else-if="isObject(ratePlan.Pricing)">
                        <b>{{ ratePlan.Pricing.ApplicableNoOfGuest }} Pax:</b> Price x {{ ratePlan.Pricing.Multiplier }} + {{ ratePlan.Pricing.Surcharge }}<br/>
                      </template>
                    </div>
                  </template>
                </template>
              </hm-col>
              <hm-button :key="`button-${idx}`"
                         class="btn--orange"
                         icon-left="link"
                         cols="12 6@tablet 2@desktop"
                         @click="openRAW({ [key]: value })">Open RAW</hm-button>
            </hm-card-inner>
          </template>
        </template>
      </tabable-card-content>
    </tabable-card>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import { isEmpty, isNil, filter, map, uniq, isObject, isArray } from 'lodash';
import HmFloatingButtons from '../../../lib/inputs/HmFloatingButtons';
import HmFloatingButton from '../../../lib/inputs/HmFloatingButton';
import Card from '../../../lib/layout/Card';
import TabableCard from '../../../lib/layout/TabableCard';
import TabableCardContent from '../../../lib/layout/TabableCardContent';
import HmCol from '../../../lib/layout/HmCol';
import HmCardInner from '../../../lib/layout/HmCardInner';
import HmTable from '../../../lib/table/HmTable';
import HmButton from '../../../lib/buttons/HmButton';
import HmInputSelect from '../../../lib/inputs/HmInputSelect';

export default {
  name: 'PageChannelManagerSuLogs',
  components: { HmInputSelect, HmButton, HmTable, HmCardInner, HmCol, TabableCardContent, TabableCard, Card, HmFloatingButton, HmFloatingButtons },
  mixins: [HotelmeisterMixin, SaveWatchMixin],

  data() {
    return {
      updateLogDate: null,
      updateLog: null,

      failedLog: null,
      channelLog: null,

      raRoomType: null,
      raRatePlan: null,
      raStartDate: null,
      raEndDate: null,
      rateInventoryLog: null,
    };
  },

  computed: {
    today() {
      return this.$moment().format('YYYYMMDD');
    },
    maxDate() {
      return this.$moment().add(730, 'days').format('YYYYMMDD');
    },
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
  },

  created: function () {
    this.updateLogDate = this.$moment().add(0, 'days').format('YYYYMMDD');
    this.raStartDate = this.$moment().add(0, 'days').format('YYYYMMDD');
    this.raEndDate = this.$moment().add(7, 'days').format('YYYYMMDD');
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    isArray,
    isObject,
    isEmpty,
    loadData() {
      this.refreshUpdateLog();
      this.refreshFailedLog();
      this.refreshRateInventoryLog();
      this.refreshChannelLog();
    },
    refreshUpdateLog() {
      if (isEmpty(this.updateLogDate)) {
        this.updateLog = null;
        return;
      }
      this.axios.get(this.serviceUrls.interfaces.channelManagerSu.logs(this, this.updateLogDate))
        .then((response) => {
          this.updateLog = response.data.data;
        })
        .catch((error) => {
          if (isEmpty(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    refreshFailedLog() {
      return this.axios.get(this.serviceUrls.interfaces.channelManagerSu.logFailed(this))
        .then((response) => {
          this.failedLog = response.data.data;
        })
        .catch((error) => {
          if (isEmpty(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    refreshRateInventoryLog() {
      if (isEmpty(this.raRoomType) || isEmpty(this.raRatePlan) || isNil(this.raStartDate) || isNil(this.raEndDate) || this.raStartDate > this.raEndDate) {
        this.rateInventoryLog = null;
        return;
      }

      this.axios.post(
        this.serviceUrls.interfaces.channelManagerSu.logRateInventory(this),
        {
          roomTypeId: this.raRoomType,
          ratePlanId: this.raRatePlan,
          fromDate: this.raStartDate,
          toDate: this.raEndDate,
        },
      )
        .then((response) => {
          this.rateInventoryLog = response.data.data;
        })
        .catch((error) => {
          if (isEmpty(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    refreshChannelLog() {
      return this.axios.get(this.serviceUrls.interfaces.channelManagerSu.logMapping(this))
        .then((response) => {
          this.channelLog = response.data.data;
        })
        .catch((error) => {
          if (isEmpty(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    openUrl(url) {
      window.open(url, '_blank', 'noopener');
    },
    openRAW(raw) {
      const windowUrl = URL.createObjectURL(new Blob([JSON.stringify(raw, null, 2)], { type: 'application/json;charset=utf-8' }));

      window.open(windowUrl, '_blank');
    },
    retryFailed() {
      return this.axios.post(this.serviceUrls.interfaces.channelManagerSu.retryFailed(this))
        .then((response) => {
          this.showSuccessMessage();
        })
        .catch((error) => {
          if (isEmpty(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageChannelManagerSuLogs.vue